import { useState, useContext, useEffect } from "react";
import UserContext from "../../contexts/UserContext";
import Uploading from "../Uploading";
import _ from "lodash";
import moment from "moment";

const FinalDocumentTab = (props) => {
  const [downloadLOC, setDownloadLOC] = useState(false);
  const { photoshootDetails } = props;
  const { userData } = useContext(UserContext);
  const [finalDocs, setFinalDocs] = useState([]); // 1 : Usage Rights , 2:  HighRes, 3: Contact Sheet, 4: LOC
  const [uploading, setUploading] = useState(false); //LOC uploading

  useEffect(() => {
    if (_.get(props, "finalDocs", []).length > 0) {
      setFinalDocs(props.finalDocs);
    }
  }, [props.finalDocs]);

  const getFinalDocs = (ftype) =>
    _.find(finalDocs, (f) => f.filetype === ftype);

  const FileNotAvailable = () => (
    <div className="mt-2 text-sm text-gray-600 font-bold  w-full">
      <div className="bg-yellow-100 text-yellow-800 w-full mb-4 p-2 rounded flex items-center">
        <i className="fas fa-exclamation-triangle mr-2"></i>
        File is yet to approved by Brand Team.
      </div>
    </div>
  );

  return (
    <>
      {photoshootDetails.status >= 11 && (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="col-span-3 text-sm text-gray-900 rounded bg-yellow-100 w-full p-2">
            <i className="fas text-red-500 fa-exclamation-triangle mr-2"></i>
            Final images & documents are available for download for 10 days
            before being archived. Please download all files by{" "}
            <span className="text-red-500 font-bold">
              {moment(photoshootDetails.loc_generated_at)
                .add(10, "days")
                .format("DD/MM/YY")}
            </span>
            .
          </div>
          {/* High Res Upload Card */}
          <div className="max-w-md w-full mx-auto bg-white rounded-xl shadow-md overflow-hidden border border-gray-200 p-6 flex flex-col items-center">
            <h3 className="text-xl font-bold text-gray-800 mb-4">
              High Resolution Package
            </h3>
            {getFinalDocs(2) && (
              <div className="w-full text-center">
                <a
                  href={getFinalDocs(2).filename}
                  download
                  className="items-center px-2 py-2 bg-blue-600 text-white text-sm font-medium rounded hover:bg-blue-700 transition"
                >
                  High Resolution Zip <i className="fas fa-download mr-2"></i>
                </a>
              </div>
            )}
            {!getFinalDocs(2) && FileNotAvailable()}
          </div>
          {/* Contact Sheet Card */}
          <div className="max-w-md w-full mx-auto bg-white rounded-xl shadow-md overflow-hidden border border-gray-200 p-6 flex flex-col items-center">
            <h3 className="text-xl font-bold text-gray-800 mb-4">
              Contact Sheet
            </h3>

            {getFinalDocs(3) && (
              <div className="w-full text-center">
                <a
                  href={getFinalDocs(3).filename}
                  download
                  className="items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded hover:bg-blue-700 transition"
                >
                  Contact Sheet <i className="fas fa-download mr-2"></i>
                </a>
              </div>
            )}
            {!getFinalDocs(3) && FileNotAvailable()}
          </div>
          {/* Usage Rights Card */}
          <div className="max-w-md w-full mx-auto bg-white rounded-xl shadow-md overflow-hidden border border-gray-200 p-6 flex flex-col items-center">
            <h3 className="text-xl font-bold text-gray-800 mb-4">
              Usage Rights
            </h3>

            {getFinalDocs(1) && (
              <div className="w-full text-center">
                <a
                  href={getFinalDocs(1).filename}
                  download
                  className="items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded hover:bg-blue-700 transition"
                >
                  Usage Rights <i className="fas fa-download mr-2"></i>
                </a>
              </div>
            )}
            {!getFinalDocs(1) && FileNotAvailable()}
          </div>
          {/* LOC */}
          {photoshootDetails.status >= 10 && (
            <>
              <div className="max-w-md w-full mx-auto bg-white rounded-xl shadow-md overflow-hidden border border-gray-200 p-6 flex flex-col items-center">
                <h3 className="text-xl font-bold text-gray-800 mb-4">
                  Letter of Compliance
                </h3>
                {uploading && <Uploading />}
                {uploading === false && (
                  <>
                    {getFinalDocs(4) && (
                      <div className="w-full text-center">
                        <a
                          href={getFinalDocs(4).filename}
                          download
                          className="items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded hover:bg-blue-700 transition"
                        >
                          Letter of Compliance{" "}
                          <i className="fas fa-download mr-2"></i>
                        </a>
                      </div>
                    )}
                  </>
                )}
              </div>
            </>
          )}
        </div>
      )}
      {photoshootDetails.status < 11 && <FileNotAvailable />}
    </>
  );
};

export default FinalDocumentTab;
